module.exports = __webpack_public_path__ + "img/q1.73aeb583.png";